import { Component, OnInit, AfterViewInit, Input, ViewChild, NgZone, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MapsAPILoader } from '@agm/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusinessTyesService } from '../../services/business-tyes.service';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit, AfterViewInit {
  contactInformationForm: FormGroup;

  @Input() subPlanDetails;
  @Input() leadId;
  @Input() filledDetails;

  contactSupplierObj = {
    alt_email: null,
    alt_phone: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    },
    first_name: null,
    middle_name: null,
    last_name: null,
    business_email: null,
    business_phone: null,
    fax_number: null,
    defaultAddress: null,
    secondary_contact: {
      name: null,
      email: null,
      phone: null
    }
  }
  contactPracticeObj = {
    alt_email: null,
    alt_phone: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    },
    first_name: null,
    middle_name: null,
    last_name: null,
    business_email: null,
    business_phone: null,
    fax_number: null,
    defaultAddress: null,
    secondary_contact: {
      name: null,
      email: null,
      phone: null
    }
  }


  detaultAddressPractice = {
    //addressName:null,
    dental_practice_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }
  detaultAddressProfessional = {
    //addressName:null,
    dental_professional_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }
  detaultAddress = {
    //addressName:null,
    dental_supplier_id: null,
    latitude: null,
    longitude: null,
    line_1: null,
    line_2: null,
    landmark: null,
    city: null,
    state: null,
    country: null,
    postal_code: null,
    make_default: null,
    short_name: null
  }

  contactProfObj = {
    alt_email: null,
    alt_phone: null,
    defaultAddress: null,
    address: {
      addressName: null,
      latitude: null,
      longitude: null,
      address_line_one: null,
      address_line_two: null,
      land_mark: null,
      city: null,
      state: null,
      country: null,
      zipcode: null
    }
  }

  @ViewChild('search',{static:false})
  public searchElementRef: ElementRef;

  localcontactinfo:any;
  countryName: any;
  stateName: any;
  addressName: any;
  pincode: any;
  professionId: any;
  latitude: any;
  longitude: any;
  private geoCoder;
  zoom: any;
  incompletelogin : any;
  phoneRegex = new RegExp(/^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/);
  emailRegex = new RegExp(
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  );
  constructor(private _fb: FormBuilder,private mapsAPILoader: MapsAPILoader,private ngZone: NgZone,private spinner: NgxSpinnerService,private businessTyesService: BusinessTyesService,private commonService: CommonService) { }

  ngAfterViewInit() {

      this.contactInformationForm.patchValue({

        //businessName:this.filledDetails.business_name,
        fName: this.filledDetails?.first_name,
        lName: this.filledDetails?.middle_name,
        mName: this.filledDetails?.last_name,
        businessPhoneNumber:this.filledDetails?.business_phone,
        businessEmail:this.filledDetails?.business_email,
        altEmail:this.filledDetails?.alt_email,
        altPhoneNo:this.filledDetails?.alt_phone,
        address:this.filledDetails?.address.addressName,
        address_line_one:this.filledDetails?.address.address_line_one,
        address_line_two:this.filledDetails?.address.address_line_two,
        land_mark:this.filledDetails?.address.land_mark,
        city:this.filledDetails?.address.city,
        state:this.filledDetails?.address.state,
        country:this.filledDetails?.address.country,
        zipcode:this.filledDetails?.address.zipcode,
        faxNumber:this.filledDetails?.fax_number,
        emailTwo:this.filledDetails?.secondary_contact.email,
        phoneNoTwo:this.filledDetails?.secondary_contact.phone,
        contactName:this.filledDetails?.secondary_contact.name
        // alt_email
        // alt_phone
        // emailTwo:this.filledDetails.abn_number
        // phoneNoTwo
        // contactName
      });

    

   

    // ...
  }

  ngOnInit(): void {

    this.mapsAPILoader.load().then(() => {
      //this.setCurrentLocation();
      //this.setCurrentPosition()
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.addressName = place
          console.log(this.addressName)
          localStorage.setItem('contactmainaddress', this.addressName.formatted_address);
          this.pincode = this.addressName.address_components.slice(-1)[0]
          this.countryName = this.addressName.address_components.slice(-2)[0]
          this.stateName = this.addressName.address_components.slice(-3)[0]
          const autoCity = this.addressName.address_components.find(addComp => addComp.types.includes("locality"));
          console.log(this.pincode)
          this.contactInformationForm.patchValue({
            address: this.addressName.formatted_address,
            state: this.stateName.long_name,
            country: this.countryName.long_name,
            zipcode: this.pincode.long_name,
            city: autoCity?.long_name || this.stateName.long_name
          })
          // if (place.geometry === undefined || place.geometry === null) {
          //   return;
          // }
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;
        });
      });
    })


    console.log(JSON.parse(localStorage.getItem("contactInfo")));
    console.log(localStorage.getItem("signupstep"))
    this.incompletelogin =localStorage.getItem("incompletelogin");
    console.log(this.incompletelogin)

    if(localStorage.getItem("contactInfo")==null){
      this.contactInformationForm = this._fb.group({
        fName: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        lName: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        mName: [null],
        businessPhoneNumber: [null, [Validators.required, Validators.pattern(this.phoneRegex)]],
        //emailtwo: [null, [Validators.required]],
        altEmail: [null, [Validators.pattern(this.emailRegex)]],
        //phoneNo: [null, [Validators.required]],
        altPhoneNo: [null, [Validators.pattern(this.phoneRegex)]],
        address_line_one: [null],
        address_line_two: [null],
        land_mark: [null],
        city: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        state: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        country: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        zipcode: [null, [Validators.required]],
        address:[null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
        businessEmail: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
        faxNumber: [null],
        emailTwo: [null, [Validators.pattern(this.emailRegex)]],
        phoneNoTwo: [null, [Validators.pattern(this.phoneRegex)]],
        contactName: [null, [Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
    });
  }else{
     this.localcontactinfo=JSON.parse(localStorage.getItem("contactInfo"));

     if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.localcontactinfo=JSON.parse(localStorage.getItem("contactInfo"));
      this.contactInformationForm = this._fb.group({
      fName: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      lName: [null, [Validators.required,Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
      mName: [null],
      businessPhoneNumber: [null, [Validators.required, Validators.pattern(this.phoneRegex)]],
      //emailtwo: [null, [Validators.required]],
      altEmail: this.localcontactinfo.alt_email,
      //phoneNo: [null, [Validators.required]],
      altPhoneNo: this.localcontactinfo.alt_phone,
      address_line_one: this.localcontactinfo.address.address_line_one,
      address_line_two: this.localcontactinfo.address.address_line_two,
      land_mark: this.localcontactinfo.address.land_mark,
      city: this.localcontactinfo.address.city,
      state: this.localcontactinfo.address.state,
      country: this.localcontactinfo.address.country,
      zipcode: this.localcontactinfo.address.zipcode,
      address:localStorage.getItem("contactmainaddress"),
      businessEmail: [null, [Validators.required, Validators.pattern(this.emailRegex)]],
      faxNumber: [null],
      emailTwo: [null, [Validators.pattern(this.emailRegex)]],
      phoneNoTwo: [null, [Validators.pattern(this.phoneRegex)]],
      contactName: [null, [Validators.pattern('.*\\S.*[a-zA-Z,./-0-9  ]')]],
    });
  }else if (this.subPlanDetails.type == "SUPPLIER") {
    this.contactInformationForm = this._fb.group({
      fName: this.localcontactinfo.first_name,
      lName: this.localcontactinfo.last_name,
      mName: this.localcontactinfo.middle_name,
      businessPhoneNumber: this.localcontactinfo.business_phone,
      //emailtwo: [null, [Validators.required]],
      altEmail: this.localcontactinfo.alt_email,
      //phoneNo: [null, [Validators.required]],
      altPhoneNo: this.localcontactinfo.alt_phone,
      address_line_one: this.localcontactinfo.address.address_line_one,
      address_line_two: this.localcontactinfo.address.address_line_two,
      land_mark: this.localcontactinfo.address.land_mark,
      city: this.localcontactinfo.address.city,
      state: this.localcontactinfo.address.state,
      country: this.localcontactinfo.address.country,
      zipcode: this.localcontactinfo.address.zipcode,
      address:localStorage.getItem("contactmainaddress"),
      businessEmail: this.localcontactinfo.business_email,
      faxNumber: this.localcontactinfo.fax_number,
      emailTwo: this.localcontactinfo.secondary_contact.email,
      phoneNoTwo: this.localcontactinfo.secondary_contact.phone,
      contactName: this.localcontactinfo.secondary_contact.name,
    });
        
  }else if (this.subPlanDetails.type == "PRACTICE") {
    this.contactInformationForm = this._fb.group({
      fName: this.localcontactinfo.first_name,
      lName: this.localcontactinfo.last_name,
      mName: this.localcontactinfo.middle_name,
      businessPhoneNumber: this.localcontactinfo.business_phone,
      //emailtwo: [null, [Validators.required]],
      altEmail: this.localcontactinfo.alt_email,
      //phoneNo: [null, [Validators.required]],
      altPhoneNo: this.localcontactinfo.alt_phone,
      address_line_one: this.localcontactinfo.address.address_line_one,
      address_line_two: this.localcontactinfo.address.address_line_two,
      land_mark: this.localcontactinfo.address.land_mark,
      city: this.localcontactinfo.address.city,
      state: this.localcontactinfo.address.state,
      country: this.localcontactinfo.address.country,
      zipcode: this.localcontactinfo.address.zipcode,
      address:localStorage.getItem("contactmainaddress"),
      businessEmail: this.localcontactinfo.business_email,
      faxNumber: this.localcontactinfo.fax_number,
      emailTwo: this.localcontactinfo.secondary_contact.email,
      phoneNoTwo: this.localcontactinfo.secondary_contact.phone,
      contactName: this.localcontactinfo.secondary_contact.name,
    });
  }

  }
  }



  get fName(): AbstractControl {
    return this.contactInformationForm.get('fName');
  }
  get lName(): AbstractControl {
    return this.contactInformationForm.get('lName');
  }
  get mName(): AbstractControl {
    return this.contactInformationForm.get('mName');
  }
  get businessPhoneNumber(): AbstractControl {
    return this.contactInformationForm.get('businessPhoneNumber');
  }
  get businessEmail(): AbstractControl {
    return this.contactInformationForm.get('businessEmail');
  }
  get faxNumber(): AbstractControl {
    return this.contactInformationForm.get('faxNumber');
  }
  get contactName(): AbstractControl {
    return this.contactInformationForm.get('contactName');
  }
  get phoneNoTwo(): AbstractControl {
    return this.contactInformationForm.get('phoneNoTwo');
  }
  get emailTwo(): AbstractControl {
    return this.contactInformationForm.get('emailTwo');
  }
  get altEmail(): AbstractControl {
    return this.contactInformationForm.get('altEmail');
  }
  get phoneNo(): AbstractControl {
    return this.contactInformationForm.get('phoneNo');
  }
  get altPhoneNo(): AbstractControl {
    return this.contactInformationForm.get('altPhoneNo');
  }
  get address_line_one(): AbstractControl {
    return this.contactInformationForm.get('address_line_one');
  }
  get address_line_two(): AbstractControl {
    return this.contactInformationForm.get('address_line_two');
  }
  get zipcode(): AbstractControl {
    return this.contactInformationForm.get('zipcode');
  }
  get land_mark(): AbstractControl {
    return this.contactInformationForm.get('land_mark');
  }
  get city(): AbstractControl {
    return this.contactInformationForm.get('city');
  }
  get state(): AbstractControl {
    return this.contactInformationForm.get('state');
  }

  get address(): AbstractControl {
    return this.contactInformationForm.get('address');
  }
  get country(): AbstractControl {
    return this.contactInformationForm.get('country');
  }




  async addContactDetails() {
    console.log('contact info step ---->', 1)
    localStorage.setItem('incompletelogin', '0');
    console.log(this.contactInformationForm.value)
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.contactInformationForm.get('fName').clearValidators();
      this.contactInformationForm.get('lName').clearValidators();
      this.contactInformationForm.get('mName').clearValidators();
      this.contactInformationForm.get('businessPhoneNumber').clearValidators();
      this.contactInformationForm.get('businessEmail').clearValidators();
      this.contactInformationForm.get('faxNumber').clearValidators();
      this.contactInformationForm.get('emailTwo').clearValidators();
      this.contactInformationForm.get('phoneNoTwo').clearValidators();
      this.contactInformationForm.get('contactName').clearValidators();
      this.contactInformationForm.get('fName').updateValueAndValidity();
      this.contactInformationForm.get('lName').updateValueAndValidity();
      this.contactInformationForm.get('mName').updateValueAndValidity();
      this.contactInformationForm.get('businessPhoneNumber').updateValueAndValidity();
      this.contactInformationForm.get('businessEmail').updateValueAndValidity();
      this.contactInformationForm.get('faxNumber').updateValueAndValidity();
      this.contactInformationForm.get('emailTwo').updateValueAndValidity();
      this.contactInformationForm.get('phoneNoTwo').updateValueAndValidity();
      this.contactInformationForm.get('contactName').updateValueAndValidity();
    }
    if (this.contactInformationForm.invalid) {
      // this.toast.openSnackBar(
      //   'Enter Valid Details'
      // );
      //this.clearForm = true;
      this.contactInformationForm.markAllAsTouched();
      return;
    }
    
    this.spinner.show()
    
    if (this.subPlanDetails.type == "PROFESSIONAL") {
      this.contactProfObj.alt_email = this.contactInformationForm.value.altEmail
      this.contactProfObj.alt_phone = this.contactInformationForm.value.altPhoneNo
      this.contactProfObj.address.addressName = localStorage.getItem("contactmainaddress")
      this.contactProfObj.address.address_line_one = this.contactInformationForm.value.address_line_one
      this.contactProfObj.address.address_line_two = this.contactInformationForm.value.address_line_two
      this.contactProfObj.address.city = this.contactInformationForm.value.city
      this.contactProfObj.address.state = this.contactInformationForm.value.state
      this.contactProfObj.address.zipcode = this.contactInformationForm.value.zipcode
      this.contactProfObj.address.land_mark = this.contactInformationForm.value.land_mark
      this.contactProfObj.address.country = this.contactInformationForm.value.country
      this.contactProfObj.address.latitude = this.latitude
      this.contactProfObj.address.longitude = this.longitude
      this.contactProfObj.defaultAddress = true
      
      await this.businessTyesService.updateProfContact(this.leadId, this.contactProfObj)
      console.log(this.contactProfObj);
      localStorage.setItem('contactInfo', JSON.stringify(this.contactProfObj));

      localStorage.setItem('signupstep', '4');
      this.spinner.hide()
      this.detaultAddressProfessional.dental_professional_id = this.leadId
      //this.detaultAddress.landmark = this.leadId
      this.detaultAddressProfessional.line_1 = this.contactProfObj.address.address_line_one
      this.detaultAddressProfessional.line_2 = this.contactProfObj.address.address_line_two
      this.detaultAddressProfessional.state = this.contactProfObj.address.state
      this.detaultAddressProfessional.city = this.contactProfObj.address.city
      this.detaultAddressProfessional.landmark = this.contactProfObj.address.land_mark
      this.detaultAddressProfessional.country = this.contactProfObj.address.country
      this.detaultAddressProfessional.latitude = this.contactProfObj.address.latitude
      this.detaultAddressProfessional.longitude = this.contactProfObj.address.longitude
      this.detaultAddressProfessional.postal_code = this.contactProfObj.address.zipcode
      //this.detaultAddressProfessional.short_name = this.userName.name
      this.detaultAddressProfessional.make_default = true
      await this.businessTyesService.defaultAddressProfessional(this.detaultAddressProfessional)
      // this.selectControl.setValue("PROFESSIONAL")
      // this.showProfessionalDetailsForm()
      this.commonService.publish('call-parent');
      // this.isCompletedThree = true
      //  altEmail: [null,[Validators.pattern(this.emailRegex)]],
      //   //phoneNo: [null, [Validators.required]],
      //   altPhoneNo: [null,[Validators.pattern(this.phoneRegex)]],
      // this.profObj.date_of_birth = this.subscriberDetailForm.value.dob
      // this.profObj.first_name = this.subscriberDetailForm.value.first_name
      // this.profObj.middle_name = this.subscriberDetailForm.value.middle_name
      // this.profObj.last_name = this.subscriberDetailForm.value.last_name
      // this.profObj.gender = this.subscriberDetailForm.value.gender
      // this.profObj.salutation = this.subscriberDetailForm.value.salutation
      // this.profObj.profile_image = this.userPhoto
      // await  this.businessTyesService.updateProf(this.leadId,this.profObj)
    }
    if (this.subPlanDetails.type == "SUPPLIER") {
      console.log('contact info step ---->', 2)
      this.contactSupplierObj.alt_email = this.contactInformationForm.value.altEmail
      this.contactSupplierObj.alt_phone = this.contactInformationForm.value.altPhoneNo
      this.contactSupplierObj.address.addressName = localStorage.getItem("contactmainaddress")
      this.contactSupplierObj.address.address_line_one = this.contactInformationForm.value.address_line_one
      this.contactSupplierObj.address.address_line_two = this.contactInformationForm.value.address_line_two
      this.contactSupplierObj.address.city = this.contactInformationForm.value.city
      this.contactSupplierObj.address.state = this.contactInformationForm.value.state
      this.contactSupplierObj.address.zipcode = this.contactInformationForm.value.zipcode
      this.contactSupplierObj.address.land_mark = this.contactInformationForm.value.land_mark
      this.contactSupplierObj.address.country = this.contactInformationForm.value.country
      this.contactSupplierObj.address.latitude = this.latitude
      this.contactSupplierObj.address.longitude = this.longitude
      this.contactSupplierObj.business_email = this.contactInformationForm.value.businessEmail
      this.contactSupplierObj.fax_number = this.contactInformationForm.value.faxNumber
      this.contactSupplierObj.secondary_contact.email = this.contactInformationForm.value.emailTwo
      this.contactSupplierObj.secondary_contact.name = this.contactInformationForm.value.contactName
      this.contactSupplierObj.secondary_contact.phone = this.contactInformationForm.value.phoneNoTwo
      this.contactSupplierObj.business_phone = this.contactInformationForm.value.businessPhoneNumber
      this.contactSupplierObj.first_name = this.contactInformationForm.value.fName
      this.contactSupplierObj.middle_name = this.contactInformationForm.value.mName
      this.contactSupplierObj.last_name = this.contactInformationForm.value.lName
      this.contactSupplierObj.defaultAddress = true
      console.log('contact info step ----> 3', this.leadId, this.contactSupplierObj)
      await this.businessTyesService.updateSupplierCon(this.leadId, this.contactSupplierObj)
      localStorage.setItem('contactInfo', JSON.stringify(this.contactSupplierObj));
      localStorage.setItem('signupstep', '4');
      this.spinner.hide()
      this.detaultAddress.dental_supplier_id = this.leadId
      //this.detaultAddress.landmark = this.leadId
      this.detaultAddress.line_1 = this.contactSupplierObj.address.address_line_one
      this.detaultAddress.line_2 = this.contactSupplierObj.address.address_line_two
      this.detaultAddress.state = this.contactSupplierObj.address.state
      this.detaultAddress.city = this.contactSupplierObj.address.city
      this.detaultAddress.landmark = this.contactSupplierObj.address.land_mark
      this.detaultAddress.country = this.contactSupplierObj.address.country
      this.detaultAddress.latitude = this.contactSupplierObj.address.latitude
      this.detaultAddress.longitude = this.contactSupplierObj.address.longitude
      this.detaultAddress.postal_code = this.contactSupplierObj.address.zipcode
      //this.detaultAddress.short_name = this.userName.name
      this.detaultAddress.make_default = true
      await this.businessTyesService.defaultAddress(this.detaultAddress)
      // this.selectControl.setValue("PROFESSIONAL")
      // this.showProfessionalDetailsForm()
      this.commonService.publish('call-parent');
      // this.isCompletedThree = true
    }
    if (this.subPlanDetails.type == "PRACTICE") {
      this.contactPracticeObj.alt_email = this.contactInformationForm.value.altEmail
      this.contactPracticeObj.alt_phone = this.contactInformationForm.value.altPhoneNo
      this.contactPracticeObj.address.addressName = localStorage.getItem("contactmainaddress")
      this.contactPracticeObj.address.address_line_one = this.contactInformationForm.value.address_line_one
      this.contactPracticeObj.address.address_line_two = this.contactInformationForm.value.address_line_two
      this.contactPracticeObj.address.city = this.contactInformationForm.value.city
      this.contactPracticeObj.address.state = this.contactInformationForm.value.state
      this.contactPracticeObj.address.zipcode = this.contactInformationForm.value.zipcode
      this.contactPracticeObj.address.land_mark = this.contactInformationForm.value.land_mark
      this.contactPracticeObj.address.country = this.contactInformationForm.value.country
      this.contactPracticeObj.address.latitude = this.latitude
      this.contactPracticeObj.address.longitude = this.longitude
      this.contactPracticeObj.business_email = this.contactInformationForm.value.businessEmail
      this.contactPracticeObj.fax_number = this.contactInformationForm.value.faxNumber
      this.contactPracticeObj.secondary_contact.email = this.contactInformationForm.value.emailTwo
      this.contactPracticeObj.secondary_contact.name = this.contactInformationForm.value.contactName
      this.contactPracticeObj.secondary_contact.phone = this.contactInformationForm.value.phoneNoTwo
      this.contactPracticeObj.business_phone = this.contactInformationForm.value.businessPhoneNumber
      this.contactPracticeObj.first_name = this.contactInformationForm.value.fName
      this.contactPracticeObj.middle_name = this.contactInformationForm.value.mName
      this.contactPracticeObj.last_name = this.contactInformationForm.value.lName
      this.contactPracticeObj.defaultAddress = true
      
      await this.businessTyesService.updatePracticeContact(this.leadId, this.contactPracticeObj)
      localStorage.setItem('contactInfo', JSON.stringify(this.contactPracticeObj));
      localStorage.setItem('signupstep', '4');
      this.spinner.hide()
      this.detaultAddressPractice.dental_practice_id = this.leadId
      //this.detaultAddress.landmark = this.leadId
      this.detaultAddressPractice.line_1 = this.contactPracticeObj.address.address_line_one
      this.detaultAddressPractice.line_2 = this.contactPracticeObj.address.address_line_two
      this.detaultAddressPractice.state = this.contactPracticeObj.address.state
      this.detaultAddressPractice.city = this.contactPracticeObj.address.city
      this.detaultAddressPractice.landmark = this.contactPracticeObj.address.land_mark
      this.detaultAddressPractice.country = this.contactPracticeObj.address.country
      this.detaultAddressPractice.latitude = this.contactPracticeObj.address.latitude
      this.detaultAddressPractice.longitude = this.contactPracticeObj.address.longitude
      this.detaultAddressPractice.postal_code = this.contactPracticeObj.address.zipcode
      //this.detaultAddressPractice.short_name = this.userName.name
      this.detaultAddressPractice.make_default = true
      await this.businessTyesService.defaultAddressPractice(this.detaultAddressPractice)
      //  await this.businessTyesService.defaultAddress(this.detaultAddress)
      // this.selectControl.setValue("PROFESSIONAL")
      this.commonService.publish('call-parent');
      // this.showProfessionalDetailsForm()
      // this.isCompletedThree = true
    }
    // const details = this.contactInformationForm.value
    // this.contactInformationForm.value.first_name = this.personalDetailsPayload.first_name
    // this.contactInformationForm.value.middle_name = this.personalDetailsPayload.middle_name
    // this.contactInformationForm.value.last_name = this.personalDetailsPayload.last_name
    // this.contactInformationForm.value.gender = this.personalDetailsPayload.gender
    // this.contactInformationForm.value.dob = this.personalDetailsPayload.dob
    // this.contactInformationForm.value.salutation = this.personalDetailsPayload.salutation
    // this.contactInformationForm.value.businessName = this.personalDetailsPayload.businessName
    // this.contactInformationForm.value.ABN_ACN_number = this.personalDetailsPayload.ABN_ACN_number
    // this.contactInformationForm.value.profile_image = this.personalDetailsPayload.profile_image
    // this.contactInformationForm.value.businessLogo = this.personalDetailsPayload.businessLogo
    // this.address.addressName = this.addressName.name
    // console.log(this.addressName.name)
    // this.address.latitude = this.latitude
    // this.address.longitude = this.longitude
    // this.address.address_line_one = this.contactInformationForm.value.address_line_one
    // this.address.address_line_two = this.contactInformationForm.value.address_line_two
    // this.address.land_mark = this.contactInformationForm.value.land_mark
    // this.address.city = this.contactInformationForm.value.city
    // this.address.state = this.contactInformationForm.value.state
    // this.address.country = this.contactInformationForm.value.country
    // this.address.zipcode = this.contactInformationForm.value.zipcode
    // this.contactInformationForm.value.address = this.address
    // this.contactInformationForm.value. = this.contactInformationForm.value.address_line_one
    // this.contactInformationForm.value.address.address_line_two = this.contactInformationForm.value.address_line_two
    // this.contactInformationForm.value.address.land_mark = this.contactInformationForm.value.land_mark
    // this.contactInformationForm.value.address.city = this.contactInformationForm.value.city
    // this.contactInformationForm.value.address.state = this.contactInformationForm.value.state
    // this.contactInformationForm.value.address.country = this.contactInformationForm.value.country
    // this.contactInformationForm.value.address.zipcode = this.contactInformationForm.value.zipcode
    // delete this.contactInformationForm.value.address_line_one
    // delete this.contactInformationForm.value.address_line_two
    // delete this.contactInformationForm.value.land_mark
    // delete this.contactInformationForm.value.city
    // delete this.contactInformationForm.value.state
    // delete this.contactInformationForm.value.country
    // delete this.contactInformationForm.value.zipcode
    // console.log(this.leadId);
    // this.signUpData.payload = this.contactInformationForm.value
    // this.detailsService.updateDetails(this.signUpData, this.leadId).then(data => {
    //   if (data) {
    //     this.toast.openSnackBar(
    //       'Your Details Submitted SuccessFully'
    //     );
    //     this.selectControl.setValue("PROFESSIONAL")
    //     this.showProfessionalDetailsForm()
    //   }
    //   console.log(data)
    //   this.contactDetailsPayload = data.payload
    // })
  }


  moveBack(){
    this.commonService.publish('call-back');
    localStorage.setItem('signupstep', '2');
    }

}
